// import React from "react";
// import { Navigate } from "react-router-dom";
// import Cookies from "js-cookie";

// export default function PublicRoute(props) {

//     return (
//         <>
//             {
//                     (Cookies.get('mhet_mst_token')) ? (
//                         <Navigate to={`/${Cookies.get('mhet_mst_project')}/home`} />
//                     )
//                         :
//                         (
//                             props.children
//                         )
//             }
//         </>
//     )
// };

import React from "react";
import { Navigate } from "react-router-dom";
import Cookies from "js-cookie";
import { preferenceReportAllowedUsers, searchCandidateAllowedUsers } from "../utils/constants";


export default function PublicRoute(props) {
  const token = Cookies.get("mhet_mst_token");
  const project = Cookies.get("mhet_mst_project");
  const userId = Cookies.get("mhet_mst_userid");

  console.log("PublicRoute → token:", token);
  console.log("PublicRoute → project:", project);
  console.log("PublicRoute → userId:", userId);
  console.log("PublicRoute → isPreferenceUser:", preferenceReportAllowedUsers.includes(String(userId)));
  console.log("PublicRoute → isSearchCandidateUser:", searchCandidateAllowedUsers.includes(String(userId)));
  if (token) {
    // 🔒 Special users → preference report
    if (preferenceReportAllowedUsers.includes(String(userId))) {
      return (
        <Navigate
          to={`/${project}/course-wise-preference-report`}
          replace
        />
      );
    } 
    if (searchCandidateAllowedUsers.includes(String(userId))) {
      return (
        <Navigate
          to={`/${project}/search-candidate`}
          replace
        />
      );
    }

    // ✅ Normal users → home
    return <Navigate to={`/${project}/home`} replace />;
  }

  // 🌐 Not logged in → public page
  return props.children;
}